import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'

const toast = {
    error: (message, title = '') => {
        return iZtoast.error({
            title: title,
            message: message,
            position: 'bottomRight'
        });
    },
    success: (message, title = '') => {
        return iZtoast.success({
            title: title,
            message: message,
            position: 'bottomRight'
        });
    },
    info: (message, title = '', noClose = false ) => {
        let obj ={
            title: title,
            message: message,
            position: 'bottomRight'
        }
            if(noClose){
                obj.timeout = false
            }
        return iZtoast.info(obj);
    }
};

export default toast;